export default __webpack_public_path__ + "static/media/icon-bedienung.06fd2bfa.svg";